module.exports = __webpack_public_path__ + "img/xishanju-2.300e1e22.jpg";